import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#066542",
      d: "M30.293 16.293a1 1 0 1 1 1.414 1.414l-14 14a1 1 0 1 1-1.414-1.414z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#066542",
      d: "M16.293 16.293a1 1 0 0 1 1.414 0l14 14a1 1 0 1 1-1.414 1.414l-14-14a1 1 0 0 1 0-1.414"
    }, null, -1)
  ]))]))
}
export default { render: render }